export const isFilterApplied = (columns) => {
  for (let i = 0; i < columns.length; i++) {
    const column = columns[i];
    const filterType = column?.filter?.filterType;
    if (!filterType) {
      continue;
    }
    if (filterType === "input" || filterType === "inputNumber") {
      const filters = column?.filter?.filters || [];
      for (let j = 0; j < filters.length; j++) {
        const fltr = filters[j];
        if (fltr.selected && fltr.value) {
          return true;
        }
      }
    } else if (filterType === "select") {
      const filters = column?.filter?.filters;
      if (filters?.value?.value) {
        return true;
      }
    } else if (filterType === "date") {
      const filters = column?.filter?.filters;
      if (filters?.startDate && filters?.endDate) {
        return true;
      }
    }
  }
  return false;
};

export const getRewardType = (title) => {
  const REWARD_TYPES = {
    payments: 0,
    "xoxo reward points": 1,
    "xoxo reward code": 2,
    "xoxo reward link": 3,
    "xoxo rewards api": 4,
  };
  return REWARD_TYPES[title];
};
